module.exports = __webpack_public_path__ + "fonts/font-icon-Enerdata.79107b6.ttf";